// src/theme.js
export const darkTheme = {
  name: 'dark',
  bg: '#0f0f11',
  surface: '#141416',
  muted: '#bdbdbd',
  accent: '#ff2d6d',
  ringColor: 'rgba(255,45,109,0.36)',
  useNeonBG: true,
  text: '#ffffff',
  glass: 'rgba(255,255,255,0.03)',
  cardShadow: '0 12px 30px rgba(0,0,0,0.6)'
};

export const lightTheme = {
  name: 'light',
  bg: 'linear-gradient(180deg,#f7f8fa,#f1f3f6)',
  surface: '#ffffff',
  muted: '#55636b',
  accent: '#2b7be9',
  ringColor: 'rgba(43,123,233,0.18)',
  useNeonBG: false,
  text: '#0b1220',
  glass: 'rgba(16,24,32,0.04)',
  cardShadow: '0 10px 30px rgba(16,24,32,0.08)'
};
